import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { QuotationStatus } from '../../services/dto/quotation-status';
import { CamQuotationStatusComponent } from './quotation-status.component';

@Component({
  host: { 'data-cid': 'grid-quotation-status-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [CamQuotationStatusComponent],
  template: `
    <div class="align-center" style="height: 100%">
      <cam-quotation-status [status]="this.status"></cam-quotation-status>
    </div>
  `,
})
export class GridQuotationStatusCellComponent extends AbstractCellComponent<any, QuotationStatus> {
  get status() {
    return this.value ?? QuotationStatus.Unknown;
  }
}
